module.exports = __webpack_public_path__ + "static/brand-wordmark-4943867380cba923a0ddc910b49b11d5.png";